import { ObjectMapper } from "json-object-mapper";
import { IModel } from "./IModel";

export class AdmissionUrlsModel implements IModel<AdmissionUrlsModel> {
  imageURL: string = "";
  admissionBenefitsPDFUrl: string = "";
  instructionsPdfUrl: string = "";
  instructionsMp4Url: string = "";

  static create(input: any): AdmissionUrlsModel {
    return ObjectMapper.deserialize<AdmissionUrlsModel>(AdmissionUrlsModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
